__turbopack_context__.v({
  "switch": "gdGMiG_switch",
});
